import entityPath from './entityPath';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const GROUP_PATH_GROUP_FRAGMENT = gql(`
  fragment groupPath_group on GroupFields {
    id
    name
  }
`);

function groupPath({
  id,
  name,
}: DocumentType<typeof GROUP_PATH_GROUP_FRAGMENT>) {
  return `/groups/${entityPath(name, id)}`;
}

export default groupPath;
